import React, { useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";

import { login, signFailed, loginNumber } from "../../redux/actions/auth";

import { Link, useHistory, useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";

import { toast, ToastContainer } from "react-toastify";
import LoginLoader from "../../components/LoginLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import "../../assets/css/style.css";
import man from "../../assets/images/avatar.png";
import {
  IconButton,
  InputAdornment,
  ThemeProvider,
  createTheme,
  Backdrop,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";

import Loader from "../../components/Loader";

import { useSelector } from "react-redux";

import axios from "axios";
import { useEffect } from "react";

const customId1 = "custom-id-yess";
export default function Resetpassword() {
  const history = useHistory();
  // const [open, setOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openn, setOpenn] = React.useState(false);

  const [value, setValue] = React.useState(0);

  const [contactus, setContactus] = useState({
    name: "",
    email: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  //   const [hideshow, setHideShow] = useState({
  //     password:'',
  //     o
  //   });
  const [type, setType] = useState(true);
  const [signType, setSignType] = useState(true);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword1 = () => setShowPassword1(!showPassword1);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword1 = () => setShowPassword1(!showPassword1);

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const handleClickOpen = () => {
    setOpenn(true);
  };

  const handleClose = () => {
    setOpenn(false);
  };

  const location = useLocation();

  let split = location.search.split("=");
  split = split[1];

  const Datee = useSelector((state) => state?.dashboardReducer?.timeSeries);
  const array = useSelector((state) => state?.usersReducer);

  const dispatch = useDispatch();

  const validationSchema = yup.object({
    newPassword: yup
      .string("Enter Your NewPassword")
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required("NewPassword is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  });

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/api/auth/v1/update/password`,
          {
            username: localStorage.getItem("username"),
            newPassword: values.newPassword,

            userId: localStorage.getItem("id"),
          }
        );

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          // await toast.success(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          setTimeout(async () => {
            await history.replace("/");
          }, 1000);
        } else {
          setOpen(false);
          // await toast.error(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  const verifytoken = async () => {
    try {
      setOpen(true);
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/api/auth/v1/verifyToken`,
        {
          token: split,
        }
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      // await toast.error("Something went wrong ! PLease check your network", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    verifytoken();
  }, []);

  const submit = useRef(null);

  const submitapi = () => {
    submit.current.click();
  };

  const modalContact = useRef(null);
  const modalContactClose = useRef(null);

  const contactModal = async () => {
    await modalContact.current.click();
  };

  return (
    <>
      <body class="g-sidenav-show login_8 bg-gray-200 bg_gradient">
        <div class="login-bg">
          <ToastContainer autoClose={5000} />
          <ThemeProvider theme={theme}>
            <Backdrop
              sx={{
                transform: "translateZ(0)",
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={open}
            >
              <Loader />
            </Backdrop>

            <main class="main-content my-aut lgin_cntnt position-relative w-auto  border-radius-l  ">
              <div></div>
              <div class="login-wrapper">
                <form onSubmit={formik.handleSubmit} class="form" id="form_f">
                  <img src={man} alt="" />
                  <h3 className="text-center text-white fw-bold ">
                    ALTRACIA - HRMS
                  </h3>
                  <h2>Reset Password</h2>
                  <div class="input-group">
                    <TextField
                      InputLabelProps={{
                        style: { color: "#fff" },
                        readOnly: true,

                        // shrink: true,
                      }}
                      required
                      value={localStorage.getItem("username")}
                      inputProps={{
                        style: { color: "white" },
                      }}
                      className="w-100"
                      label="Username"
                      variant="standard"
                    />
                    {/* <input type="text" name="loginUser" id="loginUser" required /> */}

                    <TextField
                      InputLabelProps={{
                        style: { color: "#fff" },
                        // shrink: true,
                      }}
                      required
                      inputProps={{
                        style: { color: "white" },
                      }}
                      className="w-100"
                      label="New Password"
                      name="newPassword"
                      // autoComplete="new-password"
                      type={showPassword ? "text" : "password"}
                      variant="standard"
                      size="small"
                      value={formik.values.newPassword}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.newPassword &&
                        Boolean(formik.errors.newPassword)
                      }
                      helperText={
                        formik.touched.newPassword && formik.errors.newPassword
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityIcon sx={{ color: "#FF652F" }} />
                              ) : (
                                <VisibilityOffIcon sx={{ color: "#FF652F" }} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* <label for="loginUser">User Name</label> */}
                  </div>
                  <div class="input-group">
                    {/* <input
                    type="password"
                    name="loginPassword"
                    id="loginPassword"
                    required
                  /> */}
                    <TextField
                      InputLabelProps={{
                        style: { color: "#fff" },
                        // shrink: true,
                      }}
                      required
                      inputProps={{
                        style: { color: "white" },
                      }}
                      className="w-100"
                      label="Confirm Password"
                      name="confirmPassword"
                      // autoComplete="new-password"
                      type={showPassword1 ? "text" : "password"}
                      variant="standard"
                      size="small"
                      value={formik.values.confirmPassword}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.confirmPassword &&
                        Boolean(formik.errors.confirmPassword)
                      }
                      helperText={
                        formik.touched.confirmPassword &&
                        formik.errors.confirmPassword
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword1}
                              onMouseDown={handleMouseDownPassword1}
                            >
                              {showPassword ? (
                                <VisibilityIcon sx={{ color: "#FF652F" }} />
                              ) : (
                                <VisibilityOffIcon sx={{ color: "#FF652F" }} />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* <label for="loginPassword">Password</label> */}
                  </div>
                  <input type="submit" value="Submit" class="submit-btn mt-4" />
                  {/* <Link to="/" class="forgot-pw">
                    Log In
                  </Link> */}
                </form>

                {/* <div id="forgot-pw" ref={forgotPassword}>
                  <form action="" class="form">
                    <a href="#" class="close">
                      &times;
                    </a>
                    <h2>Reset Password</h2>
                    <div class="input-group">
                      <input type="email" name="email" id="email" required />
                      <label for="email">Email</label>
                    </div>
                    <input type="submit" value="Submit" class="submit-btn" />
                  </form>
                </div> */}
              </div>
            </main>
          </ThemeProvider>
        </div>
      </body>
    </>
  );
}
